// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "select,\ninput {\n  background-color: #fff;\n  color: #272727;\n  border: none;\n  outline: none;\n  border-bottom: 1px solid #272727;\n  padding: 0.5rem;\n}\n\nselect {\n  min-width: 80px;\n  margin-right: 0.5rem;\n}\n\nh2 {\n  font-size: 1rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
